export default __webpack_public_path__ + "static/arts_crafts-8ed304791ebf3c2d9404bc8320c83d36.png";